module.exports = __webpack_public_path__ + "static/media/slider3.78d67ff2.jpg";